
import { Input } from "@/components/ui/input";

interface DeliveryInformationProps {
  address: string;
  city: string;
  postalCode: string;
  specialInstructions: string;
  onAddressChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCityChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPostalCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSpecialInstructionsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DeliveryInformation = ({
  address,
  city,
  postalCode,
  specialInstructions,
  onAddressChange,
  onCityChange,
  onPostalCodeChange,
  onSpecialInstructionsChange,
}: DeliveryInformationProps) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Delivery Information</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Street Address</label>
          <Input 
            required 
            value={address}
            onChange={onAddressChange}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">City</label>
            <Input 
              required 
              value={city}
              onChange={onCityChange}
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">ZIP Code</label>
            <Input 
              required 
              value={postalCode}
              onChange={onPostalCodeChange}
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Special Instructions</label>
          <Input 
            value={specialInstructions}
            onChange={onSpecialInstructionsChange}
            placeholder="Delivery instructions, gate code, etc."
          />
        </div>
      </div>
    </div>
  );
};
